// Report tables (from the Reports page) that a user can pin onto their Dashboard.
export const PINNABLE_REPORTS = {
  "vehicle-pl": {
    title: "Vehicle P&L",
    endpoint: "/reports/vehicle-pl",
    getRows: (d) => d?.rows || [],
    rowKey: (r) => r.vehicle_number,
    columns: [
      { key: "vehicle_number", label: "Vehicle", mono: true },
      { key: "lr_count", label: "LRs" },
      { key: "freight", label: "Freight", money: true },
      { key: "expense", label: "Expense", money: true },
      { key: "profit", label: "Profit", money: true, profit: true },
    ],
  },
  gst: {
    title: "Quarterly GST",
    endpoint: "/reports/gst-summary",
    getRows: (d) => d?.rows || [],
    rowKey: (r) => r.quarter,
    columns: [
      { key: "quarter", label: "Quarter" },
      { key: "invoice_count", label: "Invoices" },
      { key: "taxable_value", label: "Taxable", money: true },
      { key: "gst_forward", label: "GST Fwd", money: true },
      { key: "gst_rcm", label: "GST RCM", money: true },
      { key: "total", label: "Total", money: true },
    ],
  },
};
